var map = {
	"./GONGSHANGBANK.png": 23307,
	"./HUITIANFUJIJIN.png": 37807,
	"./LIANWANGQINGSUAN.png": 16366,
	"./SHANGHAIBANK.png": 1206,
	"./ZHONGGUOYINLIAN.png": 63824,
	"./ba.png": 46785,
	"./footer-110.png": 38375,
	"./footer-CUAM.png": 55056,
	"./footer-ICBKCNBJ.png": 63976,
	"./footer-ShanghaiBank.png": 94836,
	"./footer-Unionpay.png": 76205,
	"./footer-WLQS.png": 50604,
	"./footer-ZFQSXHHYZ.png": 66892,
	"./footer-ZFYWXKZ.png": 64909,
	"./footer-ZJGS.png": 35647,
	"./footer-adss@2x.png": 23004,
	"./footer-cfca@2x.png": 24738,
	"./footer-iso@2x.png": 24275,
	"./footer-logo.png": 99915,
	"./footer-pcidss@2x.png": 56251,
	"./footer-symantec@2x.png": 93176,
	"./footer-updss@2x.png": 58461,
	"./logo.png": 67401,
	"./wechat-er-code.png": 45725,
	"./wechat.png": 71478,
	"./weibo.png": 56871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96162;